/* SLIDE 29 */
/* SLIDE 30 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ButtonBot from "shared/components/ButtonBot";
import Popup from "shared/components/Popup";
import SearchBar from "../../../shared/components/SearchBar";
import AppCheckBox from "../../../shared/components/AppCheckBox";
import closeIcon from 'assets/icons/close.svg';


const ParkingSettingList = () => {
    const navigate = useNavigate();
    const [showCancelPopup, setShowCancelPopup] = useState(false);
    const [showSavePopup, setShowSavePopup] = useState(false);

    const [selectedLocation, setSelectedLocation] = useState("홍길동");
    const [workDays, setWorkDays] = useState({
        monday: {
            checked: true,
            startHour: "09",
            startMinute: "00",
            endHour: "09",
            endMinute: "00",
        },
        tuesday: {
            checked: true,
            startHour: "09",
            startMinute: "00",
            endHour: "09",
            endMinute: "00",
        },
        wednesday: {
            checked: false,
            startHour: "09",
            startMinute: "00",
            endHour: "09",
            endMinute: "00",
        },
        thursday: {
            checked: false,
            startHour: "09",
            startMinute: "00",
            endHour: "09",
            endMinute: "00",
        },
        friday: {
            checked: false,
            startHour: "09",
            startMinute: "00",
            endHour: "09",
            endMinute: "00",
        },
        saturday: {
            checked: false,
            startHour: "09",
            startMinute: "00",
            endHour: "09",
            endMinute: "00",
        },
        sunday: {
            checked: false,
            startHour: "09",
            startMinute: "00",
            endHour: "09",
            endMinute: "00",
        },
    });

    const daysOfWeek = {
        monday: "월요일",
        tuesday: "화요일",
        wednesday: "수요일",
        thursday: "목요일",
        friday: "금요일",
        saturday: "토요일",
        sunday: "일요일",
    };

    const handleCheckboxChange = (day) => {
        setWorkDays({
            ...workDays,
            [day]: {
                ...workDays[day],
                checked: !workDays[day].checked,
            },
        });
    };

    const handleTimeChange = (day, timeType, value) => {
        setWorkDays({
            ...workDays,
            [day]: {
                ...workDays[day],
                [timeType]: value,
            },
        });
    };

    const handleSaveClick = () => {
        setShowSavePopup(true);
    };
    const handleCloseSavePopup = () => {
        setShowSavePopup(false);
    };
    const handleCancelClick = () => {
        setShowCancelPopup(true);
    };

    const handleCloseCancelPopup = () => {
        setShowCancelPopup(false);
    };

    const handleConfirmCancel = () => {
        // Navigate back to schedule management
        navigate("/schedule_management");
    };

    const handleSave = () => {
        // Here you would typically save the data to a backend
        console.log("Saving work schedule:", {
            location: selectedLocation,
            workDays,
        });

        // Check employee working status based on the set schedule
        checkEmployeeStatus();
        // Navigate back to schedule management after saving
        navigate("/schedule_management");
    };

    const checkEmployeeStatus = () => {
        const now = new Date();
        const day = now.getDay(); // 0 is Sunday, 1 is Monday, etc.
        const currentHour = now.getHours().toString().padStart(2, "0");
        const currentMinute = now.getMinutes().toString().padStart(2, "0");
        const dayKeys = [
            "sunday",
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
        ];

        const todayKey = dayKeys[day];
        if (!workDays[todayKey] || !workDays[todayKey].checked) {
            console.log("Employee is not scheduled to work today");
            return;
        }

        const { startHour, startMinute, endHour, endMinute } = workDays[todayKey];
        const startTime = `${startHour}:${startMinute}`;
        const endTime = `${endHour}:${endMinute}`;
        const currentTime = `${currentHour}:${currentMinute}`;

        if (currentTime >= startTime && currentTime <= endTime) {
            console.log("Employee is currently working");
        } else {
            console.log("Employee is not currently working");
        }
    };
    return (
        <div className="work-schedule-container">
            <SearchBar placeholder="주차장명 또는 관리번호로 검색 ..." />
            <div className="htContent">
                <div className="data-table">
                    <div className="table-labels2 mn-table-labels2">
                        <AppCheckBox ></AppCheckBox>
                        <span>차량번호</span>
                        <span>입차일시</span>
                        <span>출차일시</span>
                        <span>미납금액</span>
                    </div>


                    <div className="table-labels-rows">
                        <div className="filter-table2" onClick={() => navigate("/parking_add_form")}>
                            <AppCheckBox></AppCheckBox>
                            <span>새마음시장</span>
                            <span>01-002</span>
                            <span>2024 - 01 - 05</span>
                            <span>2024 - 01 - 05</span>
                        </div>


                    </div>

                </div>
                <ButtonBot
                    textYes="저장하기"
                    textNo="취소하기"
                    handleYes={() => navigate("/parking_add_form")}
                    handleNo={handleCancelClick}
                />

                {/* Save Confirmation Popup */}
                {showSavePopup && (
                    <Popup title="스케줄 저장" textYes="저장" textNo="닫기" handleYes={handleSave} handleNo={handleCloseSavePopup} setVisible={setShowSavePopup}>
                        <div className="confirm-popup-body">

                            <p>변경된 스케줄이 저장됩니다.</p>
                            <p>저장하시겠습니까?</p>
                        </div>

                    </Popup>
                )}
            </div>


            {/* Cancel Confirmation Popup */}
            {showCancelPopup && (
                <Popup title="스케줄 취소" textYes="스케줄 취소" textNo="닫기" handleYes={handleSave} handleNo={handleCloseCancelPopup} setVisible={setShowCancelPopup}>
                    <div className="confirm-popup-body">

                        <p>변경사항이 저장되지 않습니다.</p>
                        <p>취소하시겠습니까?</p>
                    </div>
                  

                </Popup>
            )}
        </div>
    );
};

export default ParkingSettingList;
